import { Icon, PageHeader } from '@evertrue/et-components';

/**
 * SMS Templates placeholder page - shows coming soon message.
 */
const SmsTemplatesController = () => {
  return (
    <div className="sms-templates-page">
      <div className="sms-templates-page--header">
        <PageHeader title="SMS Templates" subtitle="Manage your SMS templates for constituent outreach" />
      </div>

      <div className="sms-templates-page--content">
        <div className="sms-templates-page--coming-soon">
          <div className="sms-templates-page--coming-soon-icon">
            <Icon icon="sms" size={3} />
          </div>
          <h2>SMS Templates Coming Soon</h2>
          <p>
            We're working on bringing SMS templates to help you reach constituents through text messages. This feature
            will allow you to create, manage, and send personalized SMS messages as part of your outreach strategy.
          </p>
          <div className="sms-templates-page--features">
            <div className="sms-templates-page--feature">
              <Icon icon="edit" />
              <span>Create and edit SMS templates</span>
            </div>
            <div className="sms-templates-page--feature">
              <Icon icon="person" />
              <span>Personalize with dynamic fields</span>
            </div>
            <div className="sms-templates-page--feature">
              <Icon icon="send" />
              <span>Send individual or bulk messages</span>
            </div>
            <div className="sms-templates-page--feature">
              <Icon icon="bar-chart" />
              <span>Track delivery and engagement</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SmsTemplatesController;
